import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import style from "./AddButton.module.css";

const AddButton = ({ onClick, title, fixedHeight = true }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const buttonClass = `${style.button} ${!fixedHeight ? style.autoHeight : ""}`;

  return (
    <Tooltip title={title} placement={isMobile ? "top" : "right"}>  
        <div
        className={buttonClass}
        variant="contained"
        color="primary"
        onClick={onClick}
        >
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.65 30H21.65V21.7H30V18.7H21.65V10H18.65V18.7H10V21.7H18.65V30ZM20.0135 40C17.2555 40 14.6638 39.475 12.2385 38.425C9.81283 37.375 7.69167 35.9417 5.875 34.125C4.05833 32.3083 2.625 30.186 1.575 27.758C0.525 25.33 0 22.7357 0 19.975C0 17.2143 0.525 14.62 1.575 12.192C2.625 9.764 4.05833 7.65 5.875 5.85C7.69167 4.05 9.814 2.625 12.242 1.575C14.67 0.525 17.2643 0 20.025 0C22.7857 0 25.38 0.525 27.808 1.575C30.236 2.625 32.35 4.05 34.15 5.85C35.95 7.65 37.375 9.76667 38.425 12.2C39.475 14.6333 40 17.2288 40 19.9865C40 22.7445 39.475 25.3362 38.425 27.7615C37.375 30.1872 35.95 32.3053 34.15 34.116C32.35 35.9263 30.2333 37.3597 27.8 38.416C25.3667 39.472 22.7712 40 20.0135 40ZM20.025 37C24.7417 37 28.75 35.3417 32.05 32.025C35.35 28.7083 37 24.6917 37 19.975C37 15.2583 35.3532 11.25 32.0595 7.95C28.7658 4.65 24.746 3 20 3C15.3 3 11.2917 4.64683 7.975 7.9405C4.65833 11.2342 3 15.254 3 20C3 24.7 4.65833 28.7083 7.975 32.025C11.2917 35.3417 15.3083 37 20.025 37Z" fill="#664499"/>
        </svg>

        </div>
    </Tooltip>    
  );
};

export default AddButton;